import { render, staticRenderFns } from "./MessagesFullViewMini.vue?vue&type=template&id=3752ef00&scoped=true&"
import script from "./MessagesFullViewMini.vue?vue&type=script&lang=js&"
export * from "./MessagesFullViewMini.vue?vue&type=script&lang=js&"
import style0 from "./MessagesFullViewMini.vue?vue&type=style&index=0&id=3752ef00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752ef00",
  null
  
)

export default component.exports